import { render, staticRenderFns } from "./contactservice.vue?vue&type=template&id=cc99bd6c&scoped=true"
import script from "./contactservice.vue?vue&type=script&lang=js"
export * from "./contactservice.vue?vue&type=script&lang=js"
import style0 from "./contactservice.vue?vue&type=style&index=0&id=cc99bd6c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc99bd6c",
  null
  
)

export default component.exports